import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ResponseUnidadEducativaProyectoModel, UnidadEducativaProyectoModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { ProyectoEducativoDataModel, ProyectoEducativoObjetivosDataModel, ResponseProyectoEducativoDataModel, ResponseProyectoEducativoObjetivosDataModel } from 'src/app/model/ProyectoEducativoData.model';
import { apiService } from 'src/app/service/api.service';
import { ProyectoEducativoComponent } from '../../proyecto-educativo.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-proyecto-educativo-objectivos',
  templateUrl: './proyecto-educativo-objectivos.component.html',
  styleUrls: ['./proyecto-educativo-objectivos.component.css']
})
export class ProyectoEducativoObjectivosComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  @Input() simulacion: boolean;
  cargando : boolean;
  dataJardin = new JardinModel();
  uniEducativaProyecto = new UnidadEducativaProyectoModel();
  proyectoEducativoObjetivosData = new ProyectoEducativoObjetivosDataModel();

  cambios: boolean;
  guardarEditar : boolean;
  guardarEditarAux :string;
  constructor(
    @Inject(ProyectoEducativoComponent) private parent: ProyectoEducativoComponent,
    private api: apiService,
  ) { }

  ngOnInit(): void {
    this.cambios = false;
    this.cargaInicial();
  }


  cargaInicial(){
    this.cargando = true;
    this.dataJardin = this.api.dataJardin;
    this.proyectoEducativo(this.dataJardin);

  }


  proyectoEducativo(dataJardin:JardinModel){
    this.api.API_POST_obtenerProyectoEducativoObjectivosData(dataJardin.id).subscribe((response: ResponseProyectoEducativoObjetivosDataModel) => {
      this.proyectoEducativoObjetivosData = response.payload;  
      this.cargando = false; 
      this.guardarEditarAux = sessionStorage.getItem('guardarEditar');
      if(this.guardarEditarAux  === 'true'){
        this.guardarEditar=true;
      }else{
        this.guardarEditar=false;
      }
    },
    (err) => {
      this.cargando = false;
      console.log(err)
    });  
  }

  guardarObjetivos(){
    this.divSpinner.nativeElement.style.display='';
    this.api.API_POST_actualizarProyectoEducativoObjetivosData(this.proyectoEducativoObjetivosData).subscribe((response: ResponseProyectoEducativoObjetivosDataModel) => {
      this.proyectoEducativoObjetivosData = response.payload;  
      this.divSpinner.nativeElement.style.display='none';
      this.cambios = false;
    },
    (err) => {
      this.divSpinner.nativeElement.style.display='none';
      console.log(err)
    });  
    
  }

  change() {
    this.cambios = true;
  }

  volver(){
    if (this.cambios == true){
      Swal.fire({
        title: 'Tiene cambios sin guardar, ¿desea continuar?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.parent.ngOnInit();
        } 
      })
    }else {
      this.parent.ngOnInit();
    } 
  }

      volver2(){

      this.parent.ngOnInit();
    
  }

}
